// extracted by mini-css-extract-plugin
export default {"root":"SectionHomeImg_root__ZFI2f","twoColGrid":"SectionHomeImg_twoColGrid__nNemk","ctaButton":"SectionHomeImg_ctaButton__F49J5"};